import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import QueueingPage from './QueueingPage';
import './QueueingPage.less';

export const prefix = 'bm-p-queueing';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: QueueingPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
